import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Input from '../generic/Input'
import Button from '../generic/Button'
import MaskedInput from '../generic/MaskedInput'
import FormRenderer from '../generic/FormRenderer'
import Checkbox from '../generic/Checkbox'
import jwt_decode from 'jwt-decode'
import { inject } from 'mobx-react'
import Label from '../generic/Label'
import { Redirect } from 'react-router-dom'

const RegisterUserForm = inject('registerUserStore')(observer(
  class RegisterUserForm extends Component {
    constructor (props) {
      super(props)
      const url = new URL(window.location.href)
      const token = url.searchParams.get('token')
      const decodedToken = jwt_decode(token)
      const companies = decodedToken.empresas.map(data => {
        return {name: data.name, id: data.id, isChecked: true}
      })
      this.props.registerUserStore.setCompanies(companies)
      this.props.registerUserStore.setIsDone(false)
    }

    render () {
      const { registerUserStore } = this.props
      if (this.props.registerUserStore.user.isDone) {
        return <Redirect to='/confirmar-usuario' />
      }
      const url = new URL(window.location.href)
      const token = url.searchParams.get('token')
      const { name, password, confirmPassword, email, phoneNumber, isFetching, companies } = registerUserStore.user
      const companiesCheckbox = companies.map((data, i) => {
        return {
          component: Checkbox,
          isChecked: data.isChecked,
          text: data.name,
          onChange: () => registerUserStore.toggleCompany(i)
        }
      })
      const registerFields = [
        {
          component: Input,
          label: 'Nome',
          type: 'text',
          name: 'name',
          id: 'register-user-name',
          value: name,
          placeholder: 'Nome'
        },
        {
          component: Input,
          label: 'Senha',
          type: 'password',
          name: 'password',
          id: 'register-user-password',
          value: password,
          placeholder: 'Senha',
          helpText: 'A senha deve conter mais de 6 caracteres, letras maiúsculas e números'
        },
        {
          component: Input,
          label: 'Confirmar senha',
          type: 'password',
          name: 'confirmPassword',
          id: 'register-user-confirm-password',
          value: confirmPassword,
          placeholder: 'Confirmar senha'
        },
        {
          component: Input,
          label: 'E-mail',
          type: 'email',
          name: 'email',
          id: 'register-user-email',
          value: email,
          placeholder: 'E-mail'
        },
        {
          component: MaskedInput,
          label: 'Telefone',
          type: 'text',
          name: 'phoneNumber',
          id: 'register-user-phone-number',
          value: phoneNumber,
          placeholder: 'Telefone',
          maskFunction: value => {
            if (value.length <= 18) {
              return ['+', '5', '5', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
            } else {
              return ['+', '5', '5', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
            }
          }
        },
        {
          component: Button,
          text: 'Cadastrar',
          type: 'submit',
          onClick: (event) => registerUserStore.verifyToken(event, token),
          id: 'register-user-submit',
          isLoading: isFetching,
          styleClass: 'app-main-button'
        }
      ]

      return (
        <form>
          <Label>Empresas</Label>
          <FormRenderer fields={companiesCheckbox} store={registerUserStore} />
          <FormRenderer fields={registerFields} store={registerUserStore} />
        </form>
      )
    }
  }
))

export default RegisterUserForm



// WEBPACK FOOTER //
// ./src/components/register-user/RegisterUserForm.js